<template>
<div class="chapter">
<div class="inner_page">
<div> <a id="lpn_v"></a></div>
<p class="dedication">For my parents and my sister,</p>
<p class="center">and in memory of my grandfather,</p>
<p class="center">Arthur Laing</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004_dedication.vue?1f6a105d